"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _1 = require("./");
var inversify_1 = require("inversify");
var Root = /** @class */ (function () {
    function Root(galleries, files, settings) {
        this.galleries = galleries;
        this.files = files;
        this.settings = settings;
    }
    var _a, _b, _c;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MediaGalleryClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.MediaGalleryFileClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.MediaGallerySettingsClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MediaGalleryClient !== "undefined" && _1.MediaGalleryClient) === "function" ? _a : Object, typeof (_b = typeof _1.MediaGalleryFileClient !== "undefined" && _1.MediaGalleryFileClient) === "function" ? _b : Object, typeof (_c = typeof _1.MediaGallerySettingsClient !== "undefined" && _1.MediaGallerySettingsClient) === "function" ? _c : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;
